import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from '~/translations';

function getLanguage(lng) {
  const languages = {
    en: 'en',
    default: 'es',
  };
  return languages[lng] || languages.default;
}

i18n.use(initReactI18next).init({
  resources,
  lng: getLanguage(window.navigator.language.split('-')[0]),
  fallbackLng: 'es',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
